import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
//import AttachFileIcon from '@material-ui/icons/AttachFile'
import AttachmentIcon from '@material-ui/icons/Attachment'
import EditIcon from '@material-ui/icons/Edit'

import t from '../utils/lang'

const styles = theme => ({
  item: {
    borderBottom: '1px solid #d9d9d9',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  link: {
    paddingLeft: '17px',
    textDecoration: 'none',
    color: '#fff',
    ':hover': {
      textDecoration: 'none'
    }
  }
});

class Attachment extends Component {
  /*state = {
    answer: null
  } */

  render() {
    const { lang, classes, attachment, statusId, handleOpen } = this.props
    const proposalSubmitted = statusId === 3 ? true : false

    return (
      <ListItem className={classes.item}>
        <Link href={attachment.link} target="_blank">
          <ListItemAvatar>
            <Avatar>
              <AttachmentIcon />
            </Avatar>
          </ListItemAvatar>
        </Link>

        <Link href={attachment.link} target="_blank" className={classes.link}>
          <ListItemText
            primary={attachment.description}
            secondary={attachment.filename}
          />
        </Link>

        <ListItemSecondaryAction>
          {!proposalSubmitted && (
            <IconButton edge="end" aria-label="Edit" title={t[lang].editAttachment} onClick={event => handleOpen(event, attachment.id)}>
              <EditIcon />
            </IconButton>)}
        </ListItemSecondaryAction>
      </ListItem>
    )
  }
}

Attachment.propTypes = {
  attachment: PropTypes.object.isRequired,
  handleOpen: PropTypes.func.isRequired
}

function mapStateToProps ({ rfpData }) {
  const { statusId, lang } = rfpData

  return {
    statusId,
    lang
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Attachment))


// WEBPACK FOOTER //
// ./src/components/Attachment.js